"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListBox = void 0;
var react_1 = __importDefault(require("react"));
var listbox_1 = require("@react-aria/listbox");
var SelectContext_1 = require("../../context/SelectContext");
var ListBox_module_scss_1 = __importDefault(require("./ListBox.module.scss"));
var ListBox = function (_a) {
    var menuProps = _a.menuProps, children = _a.children, id = _a.id;
    var ref = react_1["default"].useRef(null);
    var state = (0, SelectContext_1.useSelectContext)().state;
    var listBoxProps = (0, listbox_1.useListBox)(__assign(__assign({}, menuProps), { disallowEmptySelection: true, autoFocus: "first" }), state, ref).listBoxProps;
    return (react_1["default"].createElement("ul", __assign({}, listBoxProps, { ref: ref, className: ListBox_module_scss_1["default"].listBox, id: id }), children));
};
exports.ListBox = ListBox;
exports.ListBox.displayName = "ListBox";
//# sourceMappingURL=ListBox.js.map